import { FilterOptions } from "../../Helpers/Constants";
import { ProjectSummary } from "../../Models/ProjectSummary";
import { ActionTypes } from "../ProjectActionTypes";
export type ProjectListAction = {
  type: any;
  payload?: ProjectListPayload;
};

export type ProjectListPayload = {
  projects?: ProjectSummary[];
  project?: ProjectSummary;
  projectName?: string;
  errorCode?: string;
  filter?: FilterOptions;
  search?: string;
};

export const fetchingProjects = () => {
  return { type: ActionTypes.GET_PROJECTS };
};

export const getProjectsSuccess = (projects: ProjectSummary[]) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.GET_PROJECTS_SUCCESS,
    payload: { projects: projects },
  };
  return projectListAction;
};

export const getProjectsError = (errorCode: string) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.GET_PROJECTS_ERROR,
    payload: { errorCode: errorCode },
  };
  return projectListAction;
};

export const setFilter = (
  filter: FilterOptions,
  projects: ProjectSummary[]
) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.SET_FILTER_PROJECTS,
    payload: { filter: filter, projects: projects },
  };
  return projectListAction;
};

export const setSearchTerm = (
  searchTerm?: string,
  projects?: ProjectSummary[]
) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.SET_SEARCH_PROJECTS,
    payload: { search: searchTerm, projects },
  };
  return projectListAction;
};

export const updateProjectsList = (project: ProjectSummary) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.UPDATE_PROJECT,
    payload: { project: project },
  };
  return projectListAction;
};

export const addProjectToList = (project: ProjectSummary) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.ADD_PROJECT,
    payload: { project: project },
  };
  return projectListAction;
};

export const deleteProjectFromList = (projectName: string) => {
  const projectListAction: ProjectListAction = {
    type: ActionTypes.DELETE_PROJECT,
    payload: { projectName: projectName },
  };
  return projectListAction;
};
